<form name="form">
    <button type="submit" class="btn btn-default" (click)="fileButton.click()" translate>
        Upload csv file
    </button>
    <input type="file" #fileButton id="new_bulk_csv" [attr.accept]="'.csv'" (change)="newBulkFile($event)" class="hidden">
</form>
